/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

// AkTheme doesn't have a small font size var
const smallFont = 12;

export const WhatsNewIntro = styled.p`
  white-space: normal;
  margin-top: 0;
  padding-top: 6px;
  color: ${token('color.text.subtle', colors.N200)};
  line-height: 1.3;
  font-size: ${smallFont}px;
  margin-bottom: ${token('space.100', '8px')};
`;

export const Card = styled.div`
  background-color: ${token(
    'color.background.accent.gray.subtlest',
    colors.N20
  )};
  padding: ${token('space.100', '8px')};
  margin: ${token('space.100', '8px')};
  border-radius: ${token('border.radius', '3px')};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Date = styled.span`
  font-size: ${smallFont}px;
  color: ${token('color.text.accent.gray', colors.N300)};
`;

export const CardInner = styled.div`
  padding: ${token('space.100', '8px')};
  background-color: ${token('elevation.surface', colors.N0)};
  border-radius: ${token('border.radius', '3px')};
  margin-top: ${token('space.100', '8px')};
  box-shadow: 0 0 1px 0 ${token('color.blanket', colors.N50A)};
`;

export const CardTitle = styled.span`
  font-size: ${token('space.200', '16px')};
  color: ${token('color.text', colors.N800)};
`;

export const LearnMoreLink = styled.a`
  color: ${token('color.link', colors.B400)};
  font-size: ${smallFont}px;
`;
